import React, { useEffect, useState, useRef } from "react";
import arrowDown from '../assets/arrowDown.svg'
import { AiOutlineSearch } from "react-icons/ai";
import locationIcon from '../assets/location.svg'

const RateCountrySelector = ({
  icon = true,
  customstyle = false,
  page,
  countryError,
  setCountryError,
  vendorCountryData,
  handleCountrySelect,
  device,
  placeholder,
  selectedCountry,
  disabled // NEW: Disabled prop
}) => {
  const [inputValue, setInputValue] = useState("");
  const [selected, setSelected] = useState(selectedCountry || "");
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOpen = () => {
    if (!disabled) setOpen(!open); // Prevent opening if disabled
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setSelected(selectedCountry || "");
  }, [selectedCountry]);

  return (
    <div
      className={`w-full  relative cursor-pointer } `}
      ref={dropdownRef}
    >
      <div
        onClick={handleOpen}
        className={`w-full h-[45px]  ${customstyle ? 'lg:h-[50px]' : 'border   xl:h-[50px] md:border-none '}   font-medium text-base lg:text-sm ${countryError === "Country is required" || countryError === "Invalid Search"
            ? " border border-[#EB0728] "
            : customstyle || disabled ? 'border-[#c1c1c180] border' : "bg-white shadow-search   md:shadow-none"
          } rounded-[80px]  py-[14px] ${customstyle ? 'bg-white  px-[18px] md:px-[20px] lg:px-[29px]' : 'px-[13px] md:rounded-r-none'} flex items-center justify-between text-center text-[14px] ${!selected && "text-[#707070]"
          } ${disabled ? "cursor-not-allowed text-ravash" : ""}`}
      >
        {selected
          ? selected.length > 15
            ? selected.substring(0, 15) + "..."
            : selected
          : <div className={`flex gap-[5px] font-normal text-base lg:text-sm ${countryError && "text-[#EB0728]"}`}>
            {icon ? <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 -960 960 960"
              width="20px"
              className={`size-[20px] ${countryError ? "text-[#EB0728]" : "text-[#707070]"}`}
              fill="currentColor"
            >
              <path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
            </svg> : null}
            {placeholder ? placeholder : <h1>Country</h1>}
          </div>}
        {device === "small" && !disabled ?
          <svg
            width="13"
            height="9"
            viewBox="0 0 13 9"
            xmlns="http://www.w3.org/2000/svg"
            className={`${countryError ? "text-[#EB0728]" : "text-[#707070]"} ${open && "rotate-180"}`}
            fill="currentColor"
          >
            <path d="M6.5 8.04167L0.25 1.79167L1.36979 0.671875L6.5 5.80208L11.6302 0.671875L12.75 1.79167L6.5 8.04167Z" />
          </svg>
          : null}
      </div>

      {!disabled && open && (
        <ul className="w-full shadow-input bg-white mt-2 overflow-y-auto flex flex-col absolute rounded-md z-[100] text-start h-[30vh]">
          <div className="flex items-center text-base lg:text-sm  px-2 sticky top-0 bg-white">
            <AiOutlineSearch size={18} className="text-gray-700" />
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value.toLowerCase())}
              placeholder={placeholder ? placeholder : "Enter country name"}
              className="placeholder:text-[#707070] font-medium  p-2 outline-none"
            />
          </div>
          {vendorCountryData
            ?.sort((a, b) => a?.vendor_country_name?.localeCompare(b?.vendor_country_name))
            ?.map((country, index) => (
              <li
                key={index}
                className={`p-2 text-sm hover:bg-sky-600 hover:text-white
                  ${country?.vendor_country_name?.toLowerCase() === selected?.toLowerCase() && "bg-sky-600 text-white"}
                  ${country?.vendor_country_name?.toLowerCase().startsWith(inputValue) ? "block" : "block"}
                  `}
                onClick={() => {
                  if (country?.vendor_country_name?.toLowerCase() !== selected.toLowerCase()) {
                    setSelected(country?.vendor_country_name);
                    setOpen(false);
                    setInputValue("");
                    handleCountrySelect(country?.vendor_country_name, country?.vendor_country_id);
                  }
                }}
              >
                {country?.vendor_country_name}

              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default RateCountrySelector;
